import { render, staticRenderFns } from "./PortfolioCardList.vue?vue&type=template&id=33de83b1&scoped=true&"
import script from "./PortfolioCardList.vue?vue&type=script&lang=js&"
export * from "./PortfolioCardList.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCardList.vue?vue&type=style&index=0&id=33de83b1&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de83b1",
  null
  
)

export default component.exports